import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25cd5c0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Are you sure you want to remove this spouse?", -1))
const _hoisted_2 = { class: "spouse-card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Only the relationship will be deleted.", -1))

import { computed, ref } from 'vue'
import { FamilyAndChildren } from '@/rd/ViewFamilyStore'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useFamilyStore } from '@/rd/FamilyStore'
import { CompositeId } from '@/rd/CompositeId'
import { AsyncUtil } from '@/util/AsyncUtil'
import Modal from '@/util/Modal.vue'
import SpouseConnector from '@/manage/SpouseConnector.vue'
import PersonCard from '@/manage/PersonCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileSpouseRemoveModal',
  setup(__props, { expose: __expose }) {

const viewPersonStore = useViewPersonStore()
const familyStore = useFamilyStore()

const personIdRef = ref<string>()
const spouseFamilyRef = ref<FamilyAndChildren>()
const modalRef = ref<InstanceType<typeof Modal>>()

const viewPersonRef = computed(() => viewPersonStore.getLoadedPerson(personIdRef.value))
const spouseIdRef = computed(() => spouseFamilyRef.value?.family.spouseOf(viewPersonRef.value?.id ?? ''))

__expose({
  open,
})

function open(personId: string, spouseFamily: FamilyAndChildren) {
  personIdRef.value = personId
  spouseFamilyRef.value = spouseFamily
  modalRef.value?.open()
}

async function removeSpouse() {
  const profileGroupId = CompositeId.getGroupId(personIdRef.value)!
  const familyId = spouseFamilyRef.value?.family.matchIds.find(id => CompositeId.hasGroupId(id, profileGroupId))
  if (!familyId)
    throw `Family match not found in profile ${profileGroupId}`

  // TODO: delete fa/mo placeholder person sets
  // TODO: delete fa/mo placeholder family (server should block if referenced by any family details)
  
  await AsyncUtil.atLeast(500, familyStore.deleteAsync(familyId))

  modalRef.value?.close()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    onOk: removeSpouse
  }, {
    title: _withCtx(() => [
      _createTextVNode("Remove spouse")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Remove")
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SpouseConnector),
        _createVNode(PersonCard, {
          "person-id": spouseIdRef.value,
          layout: "small",
          "show-profile-type": "",
          "show-profile-count": "multiple",
          static: ""
        }, null, 8, ["person-id"])
      ]),
      _hoisted_3
    ]),
    _: 1
  }, 512))
}
}

})